/**
 * @generated SignedSource<<6af641c6cc5610ea8b4f5df8bc1c88aa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type MutationStatus = "ERROR" | "OK" | "OK_NOT_MODIFIED" | "%future added value";
export type TriggerWorkflowEventInput = {
  clientMutationId: string;
  code?: string | null;
  eventIdentifier: string;
  matterId?: string | null;
  payloadJSON: any;
  tenantId: string;
  workflowIdentifier: string;
};
export type useTriggerWorkflowEventMutation$variables = {
  input: TriggerWorkflowEventInput;
};
export type useTriggerWorkflowEventMutation$data = {
  readonly triggerWorkflowEvent: {
    readonly errors: ReadonlyArray<{
      readonly code: string;
      readonly message: string;
      readonly path: ReadonlyArray<string>;
      readonly type: string;
    }> | null;
    readonly status: MutationStatus;
  } | null;
};
export type useTriggerWorkflowEventMutation = {
  response: useTriggerWorkflowEventMutation$data;
  variables: useTriggerWorkflowEventMutation$variables;
};
const node: ConcreteRequest = function () {
  var v0 = [{
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }],
    v1 = [{
      "alias": null,
      "args": [{
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }],
      "concreteType": "TriggerWorkflowEventPayload",
      "kind": "LinkedField",
      "name": "triggerWorkflowEvent",
      "plural": false,
      "selections": [{
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      }, {
        "alias": null,
        "args": null,
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [{
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        }, {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "path",
          "storageKey": null
        }, {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "message",
          "storageKey": null
        }, {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "type",
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }];
  return {
    "fragment": {
      "argumentDefinitions": v0 /*: any*/,
      "kind": "Fragment",
      "metadata": null,
      "name": "useTriggerWorkflowEventMutation",
      "selections": v1 /*: any*/,
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0 /*: any*/,
      "kind": "Operation",
      "name": "useTriggerWorkflowEventMutation",
      "selections": v1 /*: any*/
    },

    "params": {
      "cacheID": "faee11ee667d9c3c9b9d911c13d97cab",
      "id": null,
      "metadata": {},
      "name": "useTriggerWorkflowEventMutation",
      "operationKind": "mutation",
      "text": "mutation useTriggerWorkflowEventMutation(\n  $input: TriggerWorkflowEventInput!\n) {\n  triggerWorkflowEvent(input: $input) {\n    status\n    errors {\n      code\n      path\n      message\n      type\n    }\n  }\n}\n"
    }
  };
}();
(node as any).hash = "288b3435b7462849b2df685d161a9ee3";
export default node;